export interface ICookieConsentData {
  consent: boolean;
}

export const defaultCookieConsent: ICookieConsentData = {
  consent: false,
};

export const CookieConsentStoreKey = 'cookie_consent';
